module.exports = __webpack_public_path__ + "img/vip-0.66a3a368.png";